var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-xs m-1",class:[{ admin: _vm.isActive }, _vm.extraClasses]},[_c('span',{staticClass:"avatar-title rounded-circle",class:['named-', _vm.name[0]]},[_vm._v(_vm._s(_vm._f("initials")(_vm.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }